import ajaxRequest from '@/utils/request';

const state = {
    default_from_city: {},
    statuses: []
};

const actions = {
    getLoadingSettings(context) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/loaders/settings/',
                success({data}) {
                    context.commit('setLoadingSetting', data);

                    resolve(data);
                }
            });
        });
    },
    saveLoadingSettings(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/loaders/settings/',
                method: 'POST',
                params,
                success({data}) {
                    context.commit('setLoadingSetting', data);

                    resolve();
                }
            });
        });
    }
};

const mutations = {
    setLoadingSetting(state, data) {
        state.default_from_city = data.default_from_city_data;
        state.statuses = data.statuses;
    }
};

export default {
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/tariffLoading.js